export const getIsFetching = (state: any) => {
  return state.customer.checkResetPasswordToken.isFetching
}

export const getIsSuccess = (state: any) => {
  return state.customer.checkResetPasswordToken.isSuccess
}

export const getIsFailure = (state: any) => {
  return state.customer.checkResetPasswordToken.isFailure
}
